import { observer } from "mobx-react-lite";
import { Layer, Source } from "react-map-gl";
import { useMapStore } from "../..";
import getUSStateShapes from "../../utils/getUSStateShapes";

export const stateShapesLayerId = "stateShapesLayer";

function StateShapesMapLayer() {
    const mapStore = useMapStore();
    if (!mapStore.isStyleLoaded)
        return null;

    return (
        <Source id="stateShapesSource" type="geojson" data={getUSStateShapes()}>
            <Layer
                id={stateShapesLayerId}
                type="fill"
                paint={{
                    "fill-opacity": 0,
                    'fill-color': "#FFF",
                }}
            />
        </Source>
    );
}

export default observer(StateShapesMapLayer);